import { AccessLevel } from '@breath-lab/types';

/**
 * Single source of truth for "is this user premium".
 *
 *   RC entitlement (live signal) ──OR──┐
 *                                      ├──▶ isPremium
 *   Firestore accessLevel (fallback) ──┘
 *
 * accessLevel is written only by the RevenueCat webhook (pinned in
 * firestore.rules), so it survives RC outages: a subscriber stays premium
 * when the RC SDK can't be reached. Levels above premium (admin, god, …)
 * count as premium.
 */
export function computeIsPremium(
  rcEntitlementActive: boolean,
  accessLevel: AccessLevel | null | undefined,
): boolean {
  return rcEntitlementActive || (accessLevel != null && accessLevel >= AccessLevel.premium);
}

export interface AccessContext {
  paywallEnabled: boolean;
  freeBreathworkIds: string[];
  freeJourneyIds: string[];
  /**
   * True when the user can access all paid content.
   * Combines Firestore accessLevel >= premium, live RevenueCat entitlement,
   * and active trial (trialStartedAt + 7 days > now).
   */
  hasFullAccess: boolean;
}

export function isBreathworkAccessible(breathworkId: string, ctx: AccessContext): boolean {
  if (!ctx.paywallEnabled) return true;
  if (ctx.freeBreathworkIds.includes(breathworkId)) return true;
  return ctx.hasFullAccess;
}

export function isJourneyAccessible(journeyId: string, ctx: AccessContext): boolean {
  if (!ctx.paywallEnabled) return true;
  if (ctx.freeJourneyIds.includes(journeyId)) return true;
  return ctx.hasFullAccess;
}
